export enum IceDashboardPeriodPickerEnum {
    WEEKLY = 'weekly',
    MONTHLY = 'monthly',
    QUARTERLY = 'quarterly',
    YEARLY = 'yearly',
}

export const IceDashboarPeriodPickerOptionsToValueMap: Record<IceDashboardPeriodPickerEnum, number> = {
    [IceDashboardPeriodPickerEnum.WEEKLY]: 0,
    [IceDashboardPeriodPickerEnum.MONTHLY]: 1,
    [IceDashboardPeriodPickerEnum.QUARTERLY]: 2,
    [IceDashboardPeriodPickerEnum.YEARLY]: 3,
};

export const IceDashboarPeriodPickerValueToOptionsMap: Record<number, IceDashboardPeriodPickerEnum> = {
    0: IceDashboardPeriodPickerEnum.WEEKLY,
    1: IceDashboardPeriodPickerEnum.MONTHLY,
    2: IceDashboardPeriodPickerEnum.QUARTERLY,
    3: IceDashboardPeriodPickerEnum.YEARLY,
};
